// Copyright (c) 2020 Comsearch, Inc., All rights reserved

// NOTE - this gets the 'default radioServiceId for a project'
// so if you create a new path either on Project Summary > Quick Add
// or on Project Summary > Path Details (new path), you will get a
// radioServiceId defaulted for you based on this logic.

// - if the project has any paths
// - - find the first not-null radioServiceId (site1 or site2)
// - - - apply that not-null radioServiceId
// - - if they're all null, then assign null.

// NOTE - this logic is defined in LEGO-7369
const getDefaultRadioServiceIdForProject = () => (dispatch, getState) => (
  getState().projectSummary.get('paths')
    .reduce((a, d) => {
      // if we've already found something that's not 5, then just return that
      if (a !== null) {
        return a
      }

      const s1 = d.getIn(['site1', 'radioServiceId'])
      const s2 = d.getIn(['site2', 'radioServiceId'])

      // if site1 has a radioServiceId that is not-null use that
      if (s1 !== null) {
        return s1

      // if site2 has a radioServiceId that is not-null use that
      } else if (s2 !== null) {
        return s2

      // if we didn't find anything from this path, just return a (which will be 5 from the initial pass)
      } else {
        return a
      }

    }, null)
)

export default getDefaultRadioServiceIdForProject
